import { useAuthContext } from "../context/AuthContext";

function useAuthMiddleware() {
  const authContext = useAuthContext();

  /**
   * This method will validate the middleware
   * @returns {boolean}
   */
  function validate() {
    return authContext.auth.user !== null;
  }

  /**
   * This method return the redirect instructions on fail
   * @returns {{ to: string, replace: boolean }}
   */
  function redirect() {
    const { pathname, search, hash } = window.location;
    if (pathname.startsWith("/portal")) {
      return { to: "/portal/invalid", replace: true };
    }

    //Keep the query string and hash so the user returns to the exact same page (filters, pagination, ...) after logging in
    return {
      to: `/login?redirect=${encodeURIComponent(pathname + search + hash)}`,
      replace: true,
    };
  }

  //return the middleware
  return { validate, redirect };
}

export default useAuthMiddleware;
